var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouseFulfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.722222 12.1841H2.88889V5.65263H10.1111V12.1841H12.2778V3.48909L6.5 0.876517L0.722222 3.48909V12.1841ZM0 13.0005V2.93637L6.5 0.000488281L13 2.93637V13.0005H9.38889V6.46906H3.61111V13.0005H0ZM4.73633 13.0005V11.7448H5.84711V13.0005H4.73633ZM5.94461 10.5512V9.29553H7.05539V10.5512H5.94461ZM7.15289 13.0005V11.7448H8.26367V13.0005H7.15289Z",
    fill: "#2C358A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseFulfilled);
export default __webpack_public_path__ + "static/media/warehouse-fulfilled.8302c76fffff15a49287ea6f6360924d.svg";
export { ForwardRef as ReactComponent };